var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Actions from '../actions/login.actions';
var initialState = {
    success: false,
    error: {
        username: null,
        password: null,
    },
};
var login = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case Actions.LOGIN_SUCCESS: {
            return __assign(__assign({}, initialState), { success: true });
        }
        case Actions.LOGIN_ERROR: {
            return {
                success: false,
                error: action.payload,
            };
        }
        default: {
            return state;
        }
    }
};
export default login;



//////////////////
// WEBPACK FOOTER
// ./src/auth/store/reducers/login.reducer.ts
// module id = 1483
// module chunks = 81